import styled from 'styled-components';

import { media } from '@bitcoin-portal/verse-web-components/dist/themes/breakpoints';

export const BannerWrapper = styled.div`
  display: flex;
  margin: auto;
  column-gap: 20px;
  flex-flow: column nowrap;

  ${media.sm`
    max-width: 600px;
    flex-flow: row nowrap;
  `}
`;

// TODO: clean up unnecessary styles
export const Container = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  box-sizing: border-box;
  width: 100%;
  margin: auto;
  margin-top: 20px;
  font-weight: 500;

  ${media.sm`
    flex-direction: column;
    width: auto;
  `}
`;
